<template>
    <form>
        <div class="edit-control">
            <h4 class="card-title">{{ $t('monitoring.title__logical_framework') }}</h4>
            <div class="row">
                <div class="col-lg-6 d-flex justify-content-between align-items-center">
                    <p>{{ $t('monitoring.title__download_logframe_template') }}</p>
                    <a :href="downloadFiles[0][$i18n.locale]"
                        target="_blank"
                        class="ml-2 btn btn-simple btn-primary"
                    >
                        {{ $t('monitoring.button__download_logframe_template') }}
                        <i class="tim-icons icon-cloud-download-93 ml-2"></i>
                    </a>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 d-flex justify-content-between align-items-center">
                    <p>{{ $t('monitoring.title__download_indicators_template') }}</p>
                    <a :href="downloadFiles[1][$i18n.locale]"
                        target="_blank"
                        class="ml-2 btn btn-simple btn-primary"
                    >
                        {{ $t('monitoring.button__download_indicators_template') }}
                        <i class="tim-icons icon-cloud-download-93 ml-2"></i>
                    </a>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-lg-6">
                    <div class="form-group file-group">
                        <p v-if="!MonitoringForm.files.logframe.logframe">{{ $t('monitoring.title__upload_logframe') }}</p>
                        <upload-file
                            v-if="MonitoringForm.initialized"
                            v-model="MonitoringForm.files.logframe.logframe"
                            class="upload-file"
                            section="logframe.logframe"
                            :select-text="$t('monitoring.button__upload_logframe')"
                            :file-data="MonitoringForm.files.logframe.logframe"
                            :is-editable="isUploadEditable"
                            :model-name="'Monitoring'"
                        >
                        </upload-file>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 d-flex justify-content-between align-items-center">
                    <a href="#"
                        target="_blank"
                        class="btn btn-simple btn-primary"
                    >
                        {{ $t('monitoring.button__monitoring_tool') }}
                    </a>
                </div>
            </div>
        </div>

        <div v-if="(loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN)" class="clearance-box mt-5 mb-5">
            <div class="col-12 pl-0 pr-0" style="overflow: hidden">
                <div class="clearance-bar">
                    <label>{{ $t('monitoring.title_clearance_box') }}</label>
                    <radio name="report.clearance"
                           class="form-check-inline"
                           value="cleared-with-condition"
                           v-model="MonitoringForm.model.logframe.clearance"
                           :disabled="!isClearanceEditable"
                    >
                        <label>{{ $t('monitoring.field_title_cleared_under_conditions') }}</label>
                    </radio>
                    <radio name="report.clearance"
                           class="form-check-inline"
                           value="cleared"
                           v-model="MonitoringForm.model.logframe.clearance"
                           :disabled="!isClearanceEditable"
                    >
                        <label>{{ $t('monitoring.field_title_cleared') }}</label>
                    </radio>
                    <radio name="report.clearance"
                           class="form-check-inline"
                           value="not-cleared"
                           v-model="MonitoringForm.model.logframe.clearance"
                           :disabled="!isClearanceEditable"
                    >
                        <label>{{ $t('monitoring.field_title_not_cleared') }}</label>
                    </radio>
                </div>
                <comment-box
                    class="form-group"
                    v-model="MonitoringForm.model.logframe.clearance_comments"
                    :is-editable="(loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN) && MonitoringForm.isEditable"
                    :comments="MonitoringForm.model.logframe.clearance_comments"
                    :pull-right="false">
                </comment-box>
                <base-button
                    v-if="this.isClearanceEditable"
                    type="primary"
                    class="validate-report pull-right mb-3 mr-3"
                    @click="validateLogframe"
                    >
                    {{ $t('monitoring.button_title_validate_logframe') }}
                </base-button>
            </div>
        </div>
        <div class="clearfix"></div>
    </form>
</template>
<script>
    import {UserRoles, FileUploadService, MonitoringForm} from '@/services';
    import {EventBus} from "@/event-bus";
    import {CommentBox} from 'src/components';

    export default {
        components: {
            MonitoringForm,
            CommentBox
        },
        data() {
            return {
                UserRoles,
                MonitoringForm,
                isClearanceEditable: false,
                isUploadEditable: false,
                downloadFiles:
                [
                    {
                        en: '/files/en/monitoring/2019/LIFE4BEST_REFERENCE_Logical_Framework_EN.xls',
                        fr: '/files/fr/monitoring/2019/LIFE4BEST_REFERENCE_Cadre_Logique_FR.xls',
                    },
                    {
                        en: '/files/en/monitoring/2019/LIFE4BEST_2020_Indicators_Guidelines_EN.pdf',
                        fr: '/files/fr/monitoring/2019/LIFE4BEST_2020_Indicateurs_Lignes-directrices_FR.pdf',
                    },
                ]
            }
        },
        async beforeCreate() {
            const vm = this;

            vm.loggedUser = vm.$store.getters['Auth/loggedUser'];
        },
        mounted() {
            setTimeout(function () {
                $('td textarea').each(function () {
                    $(this).css('min-height', $(this).closest('td').height())
                })
            }, 200);

            // disable fields for edit
            var elements  = document.querySelectorAll(".edit-control textarea, .edit-control input[type='text']");
            for (var i = 0, l = elements.length; i < l; ++i) {
                elements[i].readOnly = true;
                elements[i].disabled=true;
            }

            this.isClearanceEditable = !(this.loggedUser.role !== UserRoles.ADMIN && this.loggedUser.role !== UserRoles.REGIONAL_ADMIN) || !MonitoringForm.isEditable;
            this.isUploadEditable = MonitoringForm.isEditable

            if (MonitoringForm.model.logframe.locked)
            {
                this.isClearanceEditable = false;
                this.isUploadEditable = false;
            }
        },
        methods:
            {
                getError(field) {
                    return this.errors.first(field);
                },
                validate() {
                    return this.$validator.validateAll().then(res => {
                        this.$emit('on-validated', res, this.model);

                        return res;
                    });
                },
                saveProgress() {
                    EventBus.$emit('monitoring-save-progress');
                },

                submit() {
                    EventBus.$emit('monitoring-submit');
                },
                async validateLogframe()
                {
                    MonitoringForm.model.logframe.locked = true;
                    MonitoringForm.model.logframe.status = 'LOCKED';

                    this.isClearanceEditable = false;
                    this.isUploadEditable = false;

                    EventBus.$emit('monitoring-save-progress');
                },
            },
    };
</script>
